import {gsap} from "gsap";
import Swiper from 'swiper';
import { Pagination, Manipulation, Navigation, Controller } from 'swiper/modules';


export const ViewAbout = {
    namespace: 'about',
    beforeEnter(data) {

    },
    afterLeave() {



    },
    afterEnter() {



        console.log('about')


        const swiperStoryImages = new Swiper('.swiper-story-images', {
            slidesPerView: 1,
            allowTouchMove: false,
        });

        const swiperStory = new Swiper('.swiper-story', {
            slidesPerView: 1,
            allowTouchMove: false,
        });



        document.querySelectorAll('.swiper-story__controls').forEach(el=>{

            el.querySelector('.swiper-button-next').addEventListener('click',()=>{
                swiperStory.slideNext()
                swiperStoryImages.slideNext()
            })

            el.querySelector('.swiper-button-prev').addEventListener('click',()=>{
                swiperStory.slidePrev()
                swiperStoryImages.slidePrev()
            })

        })




        let $provNavLinks = document.querySelectorAll('.block-prodtab__nav a');
        let $tabWrap = document.querySelector('.block-prodtab__tab-wrap');
        let $tabs = document.querySelectorAll('.block-prodtab__tab');

        $provNavLinks.forEach(el=>{
            el.addEventListener('click',()=>{

                $provNavLinks.forEach(item=>{
                    item.classList.remove('active')
                })

                el.classList.add('active')



                gsap.to('.block-prodtab__tab',{
                    opacity: 0,
                    onStart: () => {

                        gsap.set($tabWrap,{
                            height : () => {
                                return $tabWrap.offsetHeight;
                            }
                        });

                    },
                    onComplete: () => {

                        $tabs.forEach(el=>{
                            el.classList.remove('active')
                        })

                        gsap.to(el.dataset.target,{
                            opacity: 1,
                            onStart: () => {

                                document.querySelector(el.dataset.target).classList.add('active');
                                gsap.set($tabWrap,{
                                    clearProps: 'all'
                                });

                            },
                        })

                    }
                })


            })
        })


        if (document.querySelectorAll('.accordion').length>0) {

            document.querySelectorAll('.accordion').forEach(el=>{

                let groups = gsap.utils.toArray(".accordion-group",el);
                let menus = gsap.utils.toArray(".accordion-menu",el);
                let menuToggles = groups.map(createAnimation);

                menus.forEach(menu => {
                    menu.addEventListener("click", () => toggleMenu(menu));
                });

                if (typeof (el.dataset.firstopen) != 'undefined') {
                    toggleMenu(menus[0]);
                }

                function toggleMenu(clickedMenu) {
                    if (clickedMenu.parentNode.classList.contains('active')) {
                        clickedMenu.parentNode.classList.remove('active');
                    } else {
                        groups.forEach(group => {
                            group.classList.remove('active');
                        });
                        clickedMenu.parentNode.classList.add('active');
                    }
                    menuToggles.forEach(toggleFn => toggleFn(clickedMenu))
                }

                function createAnimation(element) {

                    let menu = element.querySelector(".accordion-menu");
                    let box  = element.querySelector(".accordion-content");

                    gsap.set(box, { height: 0});

                    let animation = gsap.to(box, {
                        height: 'auto',
                        duration: 0.5,
                        ease: "power1.inOut",
                    }).reverse();

                    return function(clickedMenu) {

                        if (clickedMenu === menu) {
                            animation.reversed(!animation.reversed());
                        } else {
                            animation.reverse();
                        }
                    }
                }

            });

        }


    }
}
